<template>
  <CCard>    
      <CCardBody>  
          <CCol sm="12" lg="12" style="padding-left: 0px; padding-right: 0px;">  
              <div class="content-wrapper">
                  <div id="app">
                     <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                        <ejs-grid ref='refdata' :dataSource='datas' height='60vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                            :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                            :editSettings='editSettings' :recordDoubleClick="recordDoubleClick" :beforeRender="beforeRender" :rowSelected='rowSelected' 
                            :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound">
                            <e-columns>                   
                              <e-column field='image_path1_url' width='140' headerText=''  :allowSorting='false' :allowFiltering='false' :template='imgPersonTemplate'></e-column>  
                              <e-column field='enterprise_id' headerText='企業帳號' aria-required="true" :isPrimaryKey='true' width='140'></e-column>
                              <e-column field='category_id' headerText='企業類別' aria-required="true" width='140'></e-column>
                              <e-column field='enterprise_name' headerText='企業名稱' aria-required="true" width='300'></e-column>
                              <e-column field='enterprise_en_name' headerText='企業英文名稱' aria-required="true" width='300'></e-column>                 
                              <e-column field='union_id' headerText='統一編號' aria-required="true" width='140'></e-column>                   
                              <e-column field='phone' headerText='公司電話' aria-required="true" width='160'></e-column>
                              <e-column field='fax' headerText='公司傳真' aria-required="true" width='140'></e-column>
                              <e-column field='address' headerText='公司地址' aria-required="true" width='300'></e-column>
                              <e-column field='web_url' headerText='公司網址' aria-required="true" width='260'></e-column>
                              <e-column field='confirmation_info' headerText='企業標籤資訊連結' aria-required="true" width='200'></e-column>
                              <e-column field='confirmation_name' headerText='企業標籤資訊名稱' aria-required="true" width='200'></e-column>
                              <e-column field='web_url' headerText='官方網址' aria-required="true" width='200'></e-column>
                              <e-column field='api_url' headerText='服務網址' aria-required="true" width='200'></e-column>
                              <e-column field='create_date' headerText='建檔日期' width='180' ></e-column>
                              <e-column field='create_id' headerText='建檔人員' width='140' ></e-column>
                              <e-column field='modify_date' headerText='異動日期' width='180' ></e-column>
                              <e-column field='modify_id' headerText='異動人員' width='140' ></e-column>
                            </e-columns>                              
                        </ejs-grid>
                      </ejs-tooltip>
                  </div>
              </div>
          </CCol>
          <div class="dialog">
              <div class="control-section">
                  <ejs-dialog ref="modalDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' :header='e_isAdd ? "新增企業用戶資料" : "修改企業用戶資料" + (e_state == 1 ? "(啟用中)" : "(停用中)")' :buttons='e_buttons' 
                      width='60%'>
                      <div formGroup="orderForm">                       
                          <div class="form-row">                          
                              <div class="form-group col-md-3">
                                <span class="about-title-verify">企業編號</span>
                                <ejs-textbox floatLabelType="Always" v-model="e_enterprise_id" :enabled="e_isAdd" aria-required="true"></ejs-textbox>                                        
                              </div>  
                              <div class="form-group col-md-3">                                
                                <span class="about-title-verify">企業類別</span>
                                <ejs-dropdownlist id='depts' :dataSource='category_datas' :fields='fields' v-model="e_category_id" ></ejs-dropdownlist>                            
                              </div>  
                              <div class="form-group col-md-3">
                                <span class="about-title-verify">統一編號</span>
                                <ejs-textbox floatLabelType="Always" v-model="e_union_id"  aria-required="true"></ejs-textbox>    
                              </div>   
                              <div class="form-group col-md-3">
                                <span class="about-title">企業簡稱</span>
                                <ejs-textbox floatLabelType="Always" v-model="e_enterprise_s_name"  aria-required="true"></ejs-textbox>    
                              </div> 
                              <div class="form-group col-md-3">       
                                <span class="about-title-verify">企業名稱</span>  
                                <ejs-textbox floatLabelType="Always" v-model="e_enterprise_name" aria-required="true"></ejs-textbox>                               
                              </div>  
                              <div class="form-group col-md-3">
                                <span class="about-title">企業英文名稱</span>
                                <ejs-textbox floatLabelType="Always" v-model="e_enterprise_en_name" aria-required="true"></ejs-textbox>    
                              </div> 
                              <div class="form-group col-md-6">
                                <div>
                                  <div style="width:20%;display: inline-block;">
                                    <span class="about-title">郵遞區號</span>
                                    <ejs-textbox floatLabelType="Always" v-model="e_zip_no"  aria-required="true"></ejs-textbox>
                                  </div>
                                  &nbsp;
                                  <div style="width:76%;display: inline-block;">
                                    <span class="about-title">公司地址</span>
                                    <ejs-textbox floatLabelType="Always" v-model="e_address"  aria-required="true"></ejs-textbox>
                                  </div>
                                </div>
                              </div>                                
                              <div class="form-group col-md-2">
                                <span class="about-title">公司負責人</span>
                                <ejs-textbox floatLabelType="Always" v-model="e_president"  aria-required="true"></ejs-textbox>    
                              </div>  
                              <div class="form-group col-md-2">
                                <span class="about-title">公司電話</span>
                                <ejs-textbox floatLabelType="Always" v-model="e_phone"  aria-required="true"></ejs-textbox>    
                              </div> 
                              <div class="form-group col-md-2">
                                <span class="about-title">公司傳真</span>
                                <ejs-textbox floatLabelType="Always" v-model="e_fax"  aria-required="true"></ejs-textbox>    
                              </div>                               
                              <div class="form-group col-md-3">
                                <span class="about-title-verify" >標籤使用年限</span>
                                <ejs-numerictextbox id="numeric" format="### 年" v-model="e_service_years" @change="onServiceYearsChange" min=0 max="20"></ejs-numerictextbox>
                              </div> 
                              <div class="form-group col-md-3">
                                <span class="about-title-verify" >標籤啟用期限</span>                      
                                <ejs-numerictextbox id="numeric" format="### 月"  v-model="e_enable_months" :enabled="false" min=0></ejs-numerictextbox>                           
                              </div>   
                              <div class="form-group col-md-4">
                                <span class="about-title">公司網站</span>
                                <ejs-textbox floatLabelType="Always" v-model="e_web_url"  aria-required="true"></ejs-textbox>    
                              </div> 
                                <div class="form-group col-md-4">
                                <span class="about-title-verify">服務網站</span>
                                <ejs-textbox floatLabelType="Always" v-model="e_api_url"  aria-required="true"></ejs-textbox>    
                              </div>                               
                              <div class="form-group col-md-4">
                                <span class="about-title-verify">入口白名單(如要多筆請用半形逗點區隔)</span>
                                <ejs-textbox floatLabelType="Always" v-model="e_white_list"  aria-required="true"></ejs-textbox>    
                              </div> 
                              
                              <div class="form-group col-md-3">
                                <span class="about-title">企業名稱圖檔</span><br/>
                                <label class="btn btn-ghost-success">
                                    <input id="upload_img" class="btn btn-dark" style="display:none;" type="file" @change="fileImageNameChange" accept="image/png, image/jpeg">
                                    <i class="e-info"><img width="30px" :src="require('../../../public/img/icon/cloud-computing.png')" alt="檔案上傳"></i>
                                </label>
                                <div class="c-avatar" style="height:80px; padding-left: 50px; height:auto; text-align:left"><img v-bind:src="e_image_path1_url" class="c-avatar-about-img" /></div>
                              </div>   
                              <div class="form-group col-md-3">
                                <span class="about-title">企業LOGO圖檔</span><br/> 
                                <label class="btn btn-ghost-success">
                                    <input id="upload_img" class="btn btn-dark" style="display:none;" type="file" @change="fileImageLogoChange" accept="image/png, image/jpeg">
                                    <i class="e-info"><img width="30px" :src="require('../../../public/img/icon/cloud-computing.png')" alt="檔案上傳"></i>
                                </label>
                                <div class="c-avatar" style="height:80px; padding-left: 50px; height:auto; text-align:left"><img v-bind:src="e_image_path2_url" class="c-avatar-about-img" /></div>  
                              </div>  
                              <div class="form-group col-md-3">
                                <ejs-checkbox :checked="e_image_activity_chk" :change="onActivityChange"></ejs-checkbox>&nbsp;<span class="about-title">企業活動圖檔</span><br/>
                                <label class="btn btn-ghost-success">
                                    <input id="upload_img" class="btn btn-dark" style="display:none;" type="file" @change="fileImageActivityChange" accept="image/png, image/jpeg">
                                    <i class="e-info"><img width="30px" :src="require('../../../public/img/icon/cloud-computing.png')" alt="檔案上傳"></i>
                                </label>
                                <div class="c-avatar" style="height:80px; padding-left: 50px; height:auto; text-align:left"><img v-bind:src="e_image_activity_path_url" class="c-avatar-about-img" /></div>
                              </div> 
                              <div class="form-group col-md-3">
                                <ejs-checkbox :checked="e_image_vip_chk" :change="onVIPChange"></ejs-checkbox>&nbsp;<span class="about-title">尊龍開場VIP</span><br/>
                                <label class="btn btn-ghost-success">
                                    <input id="upload_img" class="btn btn-dark" style="display:none;" type="file" @change="fileImageVIPChange" accept="image/png, image/jpeg">
                                    <i class="e-info"><img width="30px" :src="require('../../../public/img/icon/cloud-computing.png')" alt="檔案上傳"></i>
                                </label>
                                <div class="c-avatar" style="height:80px; padding-left: 50px; height:auto; text-align:left"><img v-bind:src="e_image_vip_path_url" class="c-avatar-about-img" /></div>
                              </div> 

                              <div class="form-group col-md-6">
                                <span class="about-title">企業標籤資訊連結</span>
                                <ejs-textbox floatLabelType="Always" v-model="e_confirmation_info"  aria-required="true"></ejs-textbox>   
                              </div>   
                              <div class="form-group col-md-6">
                                <span class="about-title">企業標籤資訊名稱</span>
                                <ejs-textbox floatLabelType="Always" v-model="e_confirmation_name"  aria-required="true"></ejs-textbox>   
                              </div>                           
                              <div class="form-group col-md-12">
                                <span class="about-title">備註</span>
                                <ejs-textbox floatLabelType="Always" :rows="1" :multiline="true" v-model="e_memo"  aria-required="true"></ejs-textbox>    
                              </div>   
                              <div class="form-group col-md-12">                          
                                <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                                  <ejs-grid ref='ref_contact_data' :dataSource='contact_datas' height='150' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                    :toolbar='toolbarContact' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' 
                                    :editSettings='editContactSettings' :beforeRender="beforeRender"
                                    :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound">
                                    <e-columns>                   
                                      <e-column field='row_id' headerText='攔號' aria-required="true" :isPrimaryKey='true' width='80'></e-column>                                   
                                      <e-column field='contact' headerText='聯絡人' aria-required="true" width='120'></e-column>
                                      <e-column field='post' headerText='職稱' aria-required="true" width='120'></e-column>                 
                                      <e-column field='cell_phone' headerText='行動電話' aria-required="true" width='160'></e-column>                   
                                      <e-column field='phone' headerText='連絡電話' aria-required="true" width='160'></e-column>
                                      <e-column field='email' headerText='電子郵件' aria-required="true" width='200'></e-column>
                                      <e-column field='memo' headerText='備註' aria-required="true" width='300'></e-column>                                        
                                    </e-columns>                              
                                  </ejs-grid>
                                </ejs-tooltip>
                              </div> 
                          </div>
                      </div>                
                  </ejs-dialog>
              </div>    
          </div>
          <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
      </CCardBody>
  </CCard>  
</template>

<style lang="scss" src="../../scss/grid.scss"></style>
<script lang="ts">

import Vue from "vue";
import Loading from 'vue-loading-overlay';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { CheckBoxComponent } from "@syncfusion/ej2-vue-buttons";
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { NumericTextBoxComponent } from "@syncfusion/ej2-vue-inputs";
import { L10n, setCulture, enableRipple } from '@syncfusion/ej2-base';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";


setCulture('en-US');
L10n.load({
'en-US': {
  'pager': {
    'currentPageInfo': '',
    'totalItemsInfo': '{1} to {2} of {0}',
  },
  'grid': {
      'Print': '列印',
      'Search': '搜尋',
      'Add': '新增',
      'Edit' : '修改',
      'Delete' : '刪除',
      'Update' : '確認',
      'Cancel' : '取消'
    }
  }
});

enableRipple(true);
Vue.use(DialogPlugin);
Vue.use(TooltipPlugin);
Vue.use(GridPlugin);
Vue.use(Loading);

let DialogObj   = undefined;
let Loader      = undefined;

export default {
name: 'Department',
components: {   
  'ejs-toast': ToastComponent,
  'ejs-numerictextbox': NumericTextBoxComponent,
  'ejs-checkbox': CheckBoxComponent
},
data: function () {
  return {
    e_selectRow : null,  e_selectData: null,
    e_isAdd: null, e_enterprise_id: null, e_enterprise_name: null, e_enterprise_en_name: null, e_enterprise_s_name: null, e_category_id: null,  
    e_union_id: null, e_president: null,  e_phone: null,  e_fax: null, e_address : null, e_zip_no : null, e_web_url : null, e_api_url : null, 
    e_white_list: null, e_service_years : null, e_enable_months: null,
    e_memo: null, e_image_path1: null, e_image_path2: null, e_image_activity_path: null, e_image_vip_path: null, e_confirmation_info: null, e_confirmation_name: null, e_state: null,
    e_image_path1_url: null, e_image_path2_url: null, e_image_activity_path_url: null,e_image_vip_path_url: null, e_image_activity_chk: false,e_image_vip_chk: false,

    e_buttons: [
      {click: this.editOkClick, buttonModel: { content: '確認', isPrimary: true } }, 
      {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
    ],
    fields: { value: 'value', text: 'text' },
    filterSettings: { type: 'CheckBox' },
    pageSettings: { pageSizes: [10, 50, 100, 200], pageCount: 4 },
    selectionSettings: { persistSelection: true },
    editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
    editContactSettings: { allowEditing: true, allowAdding: true, allowDeleting: true, showAddNewRow: true, },
    toolbar: null,
    toolbarContact: ['Add', 'Edit', 'Delete', 'Update', 'Cancel', 'Print', 'Search'],


    datas: null, category_datas: null, contact_datas: null,
    position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
    imgPersonTemplate: function () { return { 
        template: Vue.component("imgPersonTemplate", {
        template:  `<img :src="image" style='width:80px' /></div>`,
            data: function () { return { data: {}, usermale: 'usermale', userfemale: 'userfemale' }; },
        computed: {
            image: function() {
                return this.data.image_path1_url;
            }
        }
    })}},
  };
},
methods: {    
  toolbarClick: function (args) {
    if (args.item.id == 'Delete') {
      DialogObj = DialogUtility.confirm({
        title: '狀態變更',
        content: `確認是否要刪除${this.e_selectData.enterprise_name}的資料嗎?`,
        okButton: {  text: 'Yes', click: this.delOkClick },
        cancelButton: {  text: 'No', click: this.delCancelClick },
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: 'Fade' }
      });
    }
    if (args.item.id == 'Status') {
      DialogObj = DialogUtility.confirm({
        title: '狀態變更',
        content: `確認是否要${this.e_state == 0 ? '啟用' : '停用'}${this.e_selectData.enterprise_name}的資料嗎?`,
        okButton: {  text: 'Yes', click: this.statusOkClick },
        cancelButton: {  text: 'No', click: this.delCancelClick },
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: 'Fade' }
      });
    }
        
    if (args.item.id == 'Add') {    
      this.e_isAdd = true;      
      this.e_enterprise_id = "";
      this.e_enterprise_name = "";
      this.e_enterprise_en_name = "";
      this.e_enterprise_s_name = "";
      this.e_category_id = null;
      this.e_union_id = "";
      this.e_president= "";
      this.e_phone = "";
      this.e_fax = "";
      this.e_address = "";
      this.e_zip_no = "";
      this.e_api_url = "";
      this.e_web_url = "";
      this.e_white_list = "";
      this.e_service_years = "3";
      this.e_enable_months = "36";
      this.e_mono = ""; 
      this.e_image_path1 = "";
      this.e_image_path2 = "";
      this.e_image_path1_url = "";
      this.e_image_path2_url = "";
      this.e_image_activity_path = "";
      this.e_image_vip_path = "";
      this.e_image_activity_path_url = "";
      this.e_image_vip_path_url = "";
      this.e_image_activity = false;
      this.e_image_vip_chk = false;
      this.e_confirmation_info = "";
      this.e_confirmation_name = "";        
      this.contact_datas = [];
      this.getEnterpriseUrlAPI();
      this.$refs.modalDialog.show();    
    }
    if (args.item.id == 'Edit') {
      this.recordDoubleClick();
    }
    if (args.item.id == "Export") {
      this.$refs.refdata.excelExport({ fileName:'企業類別資料.xlsx' });
    }   
  },   
  onQueryCellInfo(args) {     
    if (args.cell) {
      args.cell.classList.add("tooltip-cell");
      args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
    }
  },
  onRowDataBound(args) {
    if (args.data.state == 2) {
      args.row.style.backgroundColor = "rgba(255, 229, 255, 0.8)"; // 數量少於 3，淡紅色
    } 
  },     
  onServiceYearsChange: function() {
    this.e_enable_months = this.e_service_years * 12;
  },
  onIsChtChange: function(args) {
    this.e_ischt = args.event.target.value;
  },
  checkHeader: function() {       
    this.toolbar = this.e_state == 0 ? 
    [
      { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false },
      { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_selectRow == undefined },
      { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_selectRow == undefined },
      { text: '啟用', tooltipText: '啟用', prefixIcon: 'e-btn-icon e-circle-check e-icons e-icon-left', id: 'Status', disabled: this.e_selectRow == undefined },     
      { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
      'Print', 'Search'] : 
    [
      { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false },
      { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_selectRow == undefined },
      { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_selectRow == undefined },
      { text: '停用', tooltipText: '停用', prefixIcon: 'e-btn-icon e-circle e-icons e-icon-left', id: 'Status', disabled: this.e_selectRow == undefined },
      { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
      'Print', 'Search']
  },
  onActivityChange:function(args) {
    this.e_image_activity_chk = args.checked;    
  },
  onVIPChange:function(args) {
    this.e_image_vip_chk = args.checked;   
  },
  rowSelected: function(args) {    
    this.e_selectRow = args.row.getAttribute('aria-rowindex');
    this.e_selectData = args.data;  
    this.e_state = this.e_selectData.state == 1; 
    this.checkHeader();
  },
  delOkClick: function() {
    DialogObj.hide();
    this.showLoading();
    this.axios({
        method: 'delete',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: '/Enterprise',
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
        data : {
          enterprise_id: this.e_enterprise_id
        }
    })
    .then((response) => {       
      if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
      this.showMsg('修改成功!');         
      this.hideLoading();
      this.getEnterpriseData();
     
    })
    .catch((error) => { this.showError(error, true) }
    ) 
  },         
  statusOkClick: function() {
    DialogObj.hide();
    this.showLoading();
    this.axios({
        method: 'put',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: '/Enterprise/State',
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
        data : {
          enterprise_id: this.e_selectData.enterprise_id
        }
    })
    .then((response) => {       
      if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
      this.showMsg('修改成功!');         
      this.hideLoading();
      this.getEnterpriseData();
     
    })
    .catch((error) => { this.showError(error, true) }
    ) 
  },       
  delCancelClick: function() {
      DialogObj.hide();
  },    
  editOkClick: function() {     

    this.showLoading();
    this.axios({
        method: this.e_isAdd ? 'post' : 'put',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: '/Enterprise',
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
        data : {
          data: {
            enterprise_id: this.e_enterprise_id,
            enterprise_name: this.e_enterprise_name,
            enterprise_en_name: this.e_enterprise_en_name,
            enterprise_s_name : this.e_enterprise_s_name,
            category_id : this.e_category_id,
            union_id: this.e_union_id,
            president : this.e_president,
            phone : this.e_phone,
            fax : this.e_fax,
            address : this.e_address,
            zip_no : this.e_zip_no,
            web_url: this.e_web_url,
            api_url: this.e_api_url,
            white_list : this.e_white_list,
            service_years: this.e_service_years,
            enable_months: this.e_enable_months,
            image_path1: this.e_image_path1,
            image_path2: this.e_image_path2,
            image_activity_path: this.e_image_activity_path,
            image_vip_path: this.e_image_vip_path,
            image_activity_chk: this.e_image_activity_chk,
            image_vip_chk: this.e_image_vip_chk,
            confirmation_info: this.e_confirmation_info,
            confirmation_name: this.e_confirmation_name,
            memo: this.e_memo         
          },
          contact: this.contact_datas
        },        
    })
    .then((response) => {       
      if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
      this.showMsg(this.e_isAdd ? '新增成功!' : '修改成功!');     
      this.$refs.modalDialog.hide();    
      this.hideLoading();
      this.getEnterpriseData();
     
    })
    .catch((error) => { this.showError(error, true) }
    ) 

  },  
  recordDoubleClick: function () {         
    this.e_isAdd = false;
    this.e_enterprise_id = this.e_selectData.enterprise_id;
    this.e_enterprise_name = this.e_selectData.enterprise_name;
    this.e_enterprise_en_name = this.e_selectData.enterprise_en_name;
    this.e_enterprise_s_name = this.e_selectData.enterprise_s_name;
    this.e_category_id = this.e_selectData.category_id;  
    this.e_union_id = this.e_selectData.union_id;
    this.e_president = this.e_selectData.president;
    this.e_phone = this.e_selectData.phone;
    this.e_fax = this.e_selectData.fax;
    this.e_address = this.e_selectData.address;
    this.e_zip_no = this.e_selectData.zip_no;
    this.e_web_url = this.e_selectData.web_url;
    this.e_api_url = this.e_selectData.api_url;
    this.e_white_list = this.e_selectData.white_list;
    this.e_service_years = this.e_selectData.service_years;
    this.e_enable_months = this.e_selectData.enable_months;
    this.e_mono = this.e_selectData.mono; 
    this.e_image_path1 = this.e_selectData.image_path1;
    this.e_image_path2 = this.e_selectData.image_path2;
    this.e_image_path1_url = this.e_selectData.image_path1_url;
    this.e_image_path2_url = this.e_selectData.image_path2_url;
    this.e_image_activity_path = this.e_selectData.image_activity_path;
    this.e_image_vip_path = this.e_selectData.image_vip_path;
    this.e_image_activity_path_url = this.e_selectData.image_activity_path_url;
    this.e_image_vip_path_url = this.e_selectData.image_vip_path_url;
    this.e_image_activity_chk = this.e_selectData.image_activity_chk;
    this.e_image_vip_chk = this.e_selectData.image_vip_chk;
    this.e_confirmation_info = this.e_selectData.confirmation_info;
    this.e_confirmation_name = this.e_selectData.confirmation_name;
    this.e_state = this.e_selectData.state == 1; 
    this.getEnterpriseContact();
    this.$refs.modalDialog.show();  
  },
  beforeRender: function (args) {
    if (args.target.closest("td")) {
      this.$refs.tooltip.content = args.target.innerText;
    }
  },
  getEnterpriseData: function () {           
    this.showLoading();
    this.axios({
        method: 'get',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: '/Enterprise',
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
    })
    .then((response) => {       
      if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.hideLoading();         
        this.datas = response.data.datas      
        this.e_selectRow = null;
        this.checkHeader();
    })
    .catch((error) => { this.showError(error, true) }
    )             
  },
  
  getEnterpriseType: function () {           

    this.axios({
        method: 'get',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: '/Enterprise/Category/Dropdown',
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
    })
    .then((response) => {       
      if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.category_datas = response.data.datas      
    })
    .catch((error) => { this.showError(error, true) }
    ) 
            
  },
  getEnterpriseContact: function () {           

    this.axios({
        method: 'get',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: `/Enterprise/Contact?id=${this.e_enterprise_id}`,
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
    })
    .then((response) => {       
      if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.contact_datas = response.data.datas      
    })
    .catch((error) => { this.showError(error, true) }
    ) 
            
  },

   getEnterpriseUrlAPI: function () {           

    this.axios({
        method: 'get',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: `/Enterprise/APIUrl`,
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
    })
    .then((response) => {       
      if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.e_api_url = response.data.datas.api_url;      
    })
    .catch((error) => { this.showError(error, true) }
    ) 
            
  },
  
  fileImageNameChange: function(e) {
      let self = this;
      let formData = new FormData();           
      formData.append('file', e.target.files[0]);
      this.axios({
          method: 'post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: '/Enterprise/Upload/Name',                   
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : formData
      })
      .then(function (response) { 
          console.log(response);
          self.e_image_path1 = response.data.datas;
          self.e_image_path1_url = response.data.msg;
  
      
      }).catch((error) => { this.showError(error, false) })
  }, 
  fileImageLogoChange: function(e) {
      let self = this;
      let formData = new FormData();           
      formData.append('file', e.target.files[0]);
      this.axios({
          method: 'post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: '/Enterprise/Upload/Logo',                   
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : formData
      })
      .then(function (response) {          
          self.e_image_path2 = response.data.datas;
          self.e_image_path2_url = response.data.msg;
  
      
      }).catch((error) => { this.showError(error, false) })
  },  
  fileImageActivityChange: function(e) {
      let self = this;
      let formData = new FormData();           
      formData.append('file', e.target.files[0]);
      this.axios({
          method: 'post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: '/Enterprise/Upload/Activity',                   
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : formData
      })
      .then(function (response) {          
          self.e_image_activity_path = response.data.datas;
          self.e_image_activity_path_url = response.data.msg;
  
      
      }).catch((error) => { this.showError(error, false) })
  },  
  fileImageVIPChange: function(e) {
      let self = this;
      let formData = new FormData();           
      formData.append('file', e.target.files[0]);
      this.axios({
          method: 'post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: '/Enterprise/Upload/VIP',                   
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : formData
      })
      .then(function (response) { 
          
          self.e_image_vip_path = response.data.datas;
          self.e_image_vip_path_url = response.data.msg;
  
      
      }).catch((error) => { this.showError(error, false) })
  },    
  showError: function (error) {     
    this.hideLoading();
    if (error.response.status == 400) {
      for(var key in error.response.data.errors){      
        this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
      }
      return;
    }   
    if (error.response.status == 401) {
      localStorage.removeItem('token'); this.$router.push('/login');
      return;
    }
    this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
  },
  showMsg: function (msg) {
    this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
  },
  showLoading() {
    Loader = this.$loading.show({
      container: this.$refs.loadingContainer,
      canCancel: true, // default false
      onCancel: this.yourCallbackMethod,
      color: 'blue',
      loader: 'bars',  // spinner, dots, bars
      width: 164,
      height: 164,
      backgroundColor: 'black',
      opacity: 0.5,
      zIndex: 999,
    });
  },
  hideLoading() {
      Loader.hide();
  }
},
provide: {
  grid: [PdfExport, ExcelExport, Sort, DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]
},
created() {
  this.checkHeader();
  this.getEnterpriseType();
  this.getEnterpriseData();
},
mounted() {
},
beforeUpdate() {
},
beforeDestroy() {
}
}
</script>
<style>
/* 設定 CustomerName 欄位的字體顏色 */
.blue-text {
color: blue !important;
}
</style>
<style lang="scss" src="../../scss/base.scss"></style>
